import Negative from 'components/Icons/Negative';
import Positive from 'components/Icons/Positive';
import {
  DifferenceValue,
  DifferenceWrapper,
} from 'components/PerformanceReturns/PerformanceReturnsStyles';
import { Table } from 'components/Table';
import {
  DEFAULT_DATE_FORMAT_WITH_TIME,
  dateISOStringToFormat,
} from 'helpers/formatters/date';
import { formatToPercent } from 'helpers/formatters/number';
import { useEffect, useState } from 'react';
import { PerformanceReturnDetails, Stream } from 'types/PerformanceReturns';

type Props = {
  data?: PerformanceReturnDetails;
  stream?: Stream | null;
  dataCompare?: PerformanceReturnDetails;
  streamCompare?: Stream | null;
  isLoading?: boolean;
};

export function ReturnTable({
  data,
  stream,
  dataCompare,
  streamCompare,
  isLoading,
}: Props) {
  const [tableData, setTableData] = useState<any>();
  const columns = [
    {
      Header: 'Month End',
      accessor: 'asOfDate',
      testid: 'asOfDate',
      Cell: (row: any) => (
        <>{row.value ? dateISOStringToFormat(row.value) : null}</>
      ),
    },
    {
      Header: 'Monthly Return',
      accessor: 'value',
      testid: 'value',
      className: 'text-right',
      Cell: (row: any) => (
        <div className='text-right'>{formatToPercent(row.value)}</div>
      ),
    },
  ];

  const columnsCompare = [
    {
      Header: `Monthly Return on ${
        stream?.dateCreated
          ? dateISOStringToFormat(
              stream.dateCreated,
              DEFAULT_DATE_FORMAT_WITH_TIME
            )
          : ''
      }`,
      accessor: 'value',
      testid: 'value',
      className: 'text-right',
      Cell: (row: any) => (
        <div className='text-right'>{formatToPercent(row.value)}</div>
      ),
    },
    {
      Header: `Monthly Return on ${
        streamCompare?.dateCreated
          ? dateISOStringToFormat(
              streamCompare.dateCreated,
              DEFAULT_DATE_FORMAT_WITH_TIME
            )
          : ''
      }`,
      accessor: 'valueCompare',
      testid: 'valueCompare',
      className: 'text-right',
      Cell: (row: any) => (
        <div className='text-right'>{formatToPercent(row.value)}</div>
      ),
    },
    {
      Header: 'Monthly Return Difference',
      accessor: 'difference',
      testid: 'difference',
      className: 'text-right',
      Cell: (row: any) => (
        <DifferenceWrapper>
          {row.value > 0 ? <Positive /> : row.value < 0 ? <Negative /> : null}
          <DifferenceValue>{formatToPercent(row.value)}</DifferenceValue>
        </DifferenceWrapper>
      ),
    },
  ];

  useEffect(() => {
    if (data && dataCompare) {
      const value = data?.value ?? 0;
      const valueCompare = dataCompare?.value ?? 0;
      const difference = value - valueCompare;
      const dataObj = {
        value,
        valueCompare,
        difference,
      };
      setTableData([dataObj]);
    } else {
      const dataObj = {
        asOfDate: data?.asOfDate,
        value: data?.value,
      };
      setTableData([dataObj]);
    }
  }, [data, dataCompare]);

  return (
    <Table
      isLoading={isLoading}
      data={tableData ?? []}
      columns={dataCompare ? columnsCompare : columns}
    />
  );
}
